import { render, staticRenderFns } from "./BerthCommodityAddModal.vue?vue&type=template&id=3e0ec354&scoped=true&"
import script from "./BerthCommodityAddModal.vue?vue&type=script&lang=js&"
export * from "./BerthCommodityAddModal.vue?vue&type=script&lang=js&"
import style1 from "./BerthCommodityAddModal.vue?vue&type=style&index=1&id=3e0ec354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0ec354",
  null
  
)

export default component.exports